module.exports = __webpack_public_path__ + "static/media/share.fc6bef62.svg";